export const getCheckedEmotionRating = items => {
  if (!items) return;

  return items
    .filter(item => item.isSelected)
    .map(item => item.rating)
    .toString();
};

export const getSelectedCheckBoxItems = items => {
  if (!items) return;

  return items
    .filter(item => item.checked)
    .map(item => item.id)
    .toString();
};
